import qs from 'qs'
import Store from 'store'
import _, { Many } from 'lodash'
import CryptoJS from 'crypto-js'
import { Str2Bytes, encode64, b64Decode } from './lib'
import { withSnackbar } from 'notistack'
import { createHashHistory } from 'history'
import moment, { Moment } from 'moment'
import UserStore from '@stores/UserStore'
import enhanceLoading from '@components/hocs/WithLoading'
import withTracker from '@components/hocs/WithTracker'
import { getPrefixApp } from '@const/common'
import { getQueryParams } from './url'
import { Login } from '@services/api'
import './ie'
import bizTool from './bizTool'
import { transform } from '@utils/intl_lang'

const hash = createHashHistory()

export const routerPush = hash.push
export const isPingAn = bizTool.isPingAn
export const isTest = bizTool.isTest
export const isOuterLink = bizTool.isOuterLink
export const getAppData = () => {
  const url = window.location.href
  const appData = {
    stg1: {
      paServerUrl: 'https://stg3-web.itp-live.pingan.com.cn:13443/',
      paAppId: '8686mIHUOn10',
      paAppKey: 'ZLDkCtXoXdUfRMkVNnVumBOAUtZHxwII',
      sdkAppID: 1400016542,
      accountType: 7849,
      bzid: 4271,
    },
    stg5: {
      paServerUrl: 'https://stg4-web.itp-live.pingan.com.cn:12443/',
      paAppId: '7877urPifZ2',
      paAppKey: 'cnyLZDmUiEKZOZReUdDiVoBNMnVVbNJR',
      sdkAppID: 1400032984,
      accountType: 7849,
      bzid: 4271,
    },
    test9: {
      paServerUrl: 'https://stg3-web.itp-live.pingan.com.cn:13443/',
      paAppId: 'togsHjGoSxW33',
      paAppKey: 'ZLDkCtXoXdUfRMkVNnVumBOAUtZHxwII',
      sdkAppID: 1400016542,
      accountType: 7849,
      bzid: 4271,
    },
    pro: {
      paServerUrl: 'https://web.itp-live.pingan.com.cn/',
      paAppId: '6059oJdWWJ586',
      paAppKey: 'xdsKdSenXaxsQfJzlQOeuPCevkbujDBA',
      sdkAppID: 1400018534,
      accountType: 8682,
      bzid: 8038,
    },
  }
  if (
    url.includes('gq-api') ||
    url.includes('gq-h5') ||
    url.includes('test') ||
    url.includes('gq-cdn') ||
    url.includes('localhost')
  ) {
    return appData.stg1
  }
  if (url.includes('test9') || url.includes('api-stg9') || url.includes('test-stg9')) {
    return appData.test9
  }
  if (url.includes('test5') || url.includes('stg5') || url.includes('api-stg5') || url.includes('test-stg5')) {
    return appData.stg5
  }
  return appData.pro
}

// 获取url query参数
export const getQueryJson = (queryString: string) => {
  const queryJson = qs.parse(queryString.replace('?', ''))
  return queryJson
}

export const getKeyPair = () => {
  return RSAUtils.getKeyPair(
    '010001',
    '',
    '00a76d0ed020e56859932b80d2e11061f58b87ed5d7b6ff9272187d9a749914d15f7a52589211ae761d9752509c71aaaf580110dd987c09cb4d738409b70ebe1337cb4fe434651cdaf4d282df68cd1a3a0aefb57d3f96807b8ae75fe9b77c975635a4666ba18e17be8ec8d8d4a5615d84131c8c2f776e9cf15af4cdcbb60021d69',
  )
}

// RSA加密字符串
export const rsaEncodeString = (str: string) => {
  let encodeStr = RSAUtils.encryptedString(
    getKeyPair(),
    RSAUtils.reverseStr(str),
  )
  encodeStr = encode64(Str2Bytes(encodeStr))
  return encodeStr
}

/**
 * @description 返回日期格式如： 2019年月2月2日
 * @param {Date} d
 * @returns {String}
 */
export const formateDate = (d: Date = new Date()) =>
  // `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`
  moment(d).format('LL')

/**
 * @description 返回日期格式如： 02月02日 02:02
 * @param {Date} d
 * @returns {String}
 */
export const formateLongDate = (d: Date = new Date()) => {
  const month =
    d.getMonth() + 1 >= 10 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`
  const date = d.getDate() >= 10 ? d.getDate() : `0${d.getDate()}`
  const hour = d.getHours() >= 10 ? d.getHours() : `0${d.getHours()}`
  const min = d.getMinutes() >= 10 ? d.getMinutes() : `0${d.getMinutes()}`
  return `${month}月${date}日 ${hour}:${min}`
}

/**
 * @description 返回日期格式如：2019年02月02日 02:02
 * @param d
 */
export const formateLongYearDate = (d: Date = new Date()) => {
  const month =
    d.getMonth() + 1 >= 10 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`
  const date = d.getDate() >= 10 ? d.getDate() : `0${d.getDate()}`
  const hour = d.getHours() >= 10 ? d.getHours() : `0${d.getHours()}`
  const min = d.getMinutes() >= 10 ? d.getMinutes() : `0${d.getMinutes()}`
  return `${d.getFullYear()}年${month}月${date}日 ${hour}:${min}`
}

export const validatePhone = (value: string) => {
  // 校验手机号，号段主要有(不包括上网卡)：
  // 130~139、150~153，155~159，180~189、170~173、176~178。
  // 14号段为上网卡专属号段
  // const regs = /^((13[0-9])|(17[0-3,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/;
  // const regs = /^(\+{0,1}86)?1\d{10}$/;   // 考虑86或+86的情况
  const regExp = /^1\d{10}$/ // 不考虑86或+86的情况
  const phoneNumber = value.trim()
  const isValid = phoneNumber !== '' && regExp.test(phoneNumber)

  if (!isValid) {
    // '手机号需为11位数字'
    global.$message(transform('phone_num'))
  }
  return isValid
}

export const getValidPass = (pass: string) => {
  if (pass.trim().length > 16) {
    // '密码长度不得超过16位'
    global.$message(transform('pwd_length'))
    return pass.substr(0, 16)
  }
  return pass.trim()
}

// 中车注销接口
export const getCancelUrl = () => {
  const url = window.location.href.toLowerCase()
  if (url.indexOf('test') !== -1) {
    const redirectUrl = 'https://test-stg5.zhi-niao.com/znWeb/znPortal/#/sifang-login'
    return `https://tpcs.4dlp.com.cn:8443/idp/authCenter/GLO?redirectToLogin=true&redirectToUrl=${encodeURIComponent(redirectUrl)}`
  } else {
    const redirectUrl = 'https://www.zhi-niao.com/znWeb/znPortal/#/sifang-login'
    return `https://tp.4dlp.com.cn:443/idp/authCenter/GLO?redirectToLogin=true&redirectToUrl=${encodeURIComponent(redirectUrl)}` // 中车的生产注销接口
  }
}

// 跳转到login页面
export const toLogin = (from = '') => {
  Store.remove('sessionInfo')
  Store.remove('refreshTime')
  Store.remove('isPcOpen') // 首页配置打开重置
  Store.remove('isSingleLogin') // 单点登录状态重置
  localStorage.removeItem('timeInRoom')
  localStorage.removeItem('firstEnterTime')
  localStorage.removeItem('opened_treasure_boxes')

  UserStore.setSid('')
  const individuationKey = Store.get('individuationKey')

  if (individuationKey) {
    hash.push(
      `/login${from ? `/${from}` : ''}?individuationKey=${individuationKey}`,
    )
    return
  }
  const params = getQueryParams(location.href.split('?')[1])
  if (params.route) {
    hash.push(`/login?route=${params.route}`)
    return
  }
  hash.push('/login')
}

// 三七互娱不同环境的企业Id
export const enterpriseIdSqList = [
  'BE6CF7B7DEEB4F879DE10461948FCFFF',  // stg1
  'C2E2A79E0C244D75BCFFD73234A6D7F0', // stg5
  'D279420F00D54073B43692CBB2CB6538', // pro
]

// 赣州银行环境的企业Id
export const enterpriseIdGZList = [
  '214941BE900145ECB2B86AF55347FD67', // stg5
  '64813711568644ECB277CCAAB59BCA6F', // pro
]

// 跳转到三七登录页
export const toLoginOutTo37 = () => {
  Store.remove('sessionInfo')
  Store.remove('refreshTime')
  Store.remove('isPcOpen') // 首页配置打开重置
  Store.remove('isSingleLogin') // 单点登录状态重置
  UserStore.setSid('')
  window.location.href = 'https://portal.37wan.com/'
}

// 赣州银行身份跳转到中台定制登录页
export const loginOutToManage = () => {
  Store.remove('sessionInfo')
  Store.remove('refreshTime')
  Store.remove('isPcOpen') // 首页配置打开重置
  Store.remove('isSingleLogin') // 单点登录状态重置
  UserStore.setSid('')
  const url = window.location.href.toLowerCase()
  if (url.indexOf('test') !== -1) {
    window.location.href = 'https://test5-hrmsv3-mlearning-admin.zhi-niao.com/learn/antd/index.html#/login?loginEnterprise=BANKOFGANZHOU'
  } else {
    window.location.href = 'https://hrmsv3-mlearning-admin.pingan.com.cn/learn/antd/index.html#/login?loginEnterprise=BANKOFGANZHOU'
  }
}

// 跳转到首页
export const toHome = () => hash.push('/home/homePage')

// 是否命中实践培训、企学友等路由名
// 针对历史业务-实践培训等模块开启白名单，当出现practice-train等前缀，允许主应用命中子应用
export const isInWhiteList = (pathName: string, prefix = '') => {
  return (
    pathName.startsWith(`${prefix}practice-train/`) ||
    pathName.startsWith(`${prefix}micro-enterprises-learning/`) ||
    pathName.startsWith(`${prefix}train-plan-expense/`) ||
    pathName.startsWith(`${prefix}mili-top-up`)
  )
}
/**
 * desc: 获取浏览器私有前缀
 */
export const getVendorPrefix = () => {
  // 使用body是为了避免在还需要传入元素
  const body = document.body || document.documentElement
  const style = body.style
  const vendor = ['webkit', 'khtml', 'moz', 'ms', 'o']
  let prefix = ''
  vendor.forEach(item => {
    if (typeof style[item + 'Transition'] === 'string') {
      prefix = item
    }
  })
  return prefix
}

/**
 * desc: 获取浏览器私有前缀
 */
export const getFullscreenChangeEventName = () => {
  let eventName = ''
  const prefix = getVendorPrefix()
  if (prefix === 'ms') {
    eventName = 'MSFullscreenChange'
  } else {
    eventName = prefix + 'fullscreenchange'
  }
  return eventName
}

// 全屏
export const setFullScreen = (ele: any) => {
  const el: any = document.documentElement
  const rfs =
    el.requestFullScreen ||
    el.webkitRequestFullScreen ||
    el.mozRequestFullScreen ||
    el.msRequestFullscreen
  if (typeof rfs !== 'undefined' && rfs) {
    rfs.call(el)
  }
  return
}
// 退出全屏
export const exitScreen = () => {
  const el: any = document
  const rfs =
    el.exitFullscreen ||
    el.webkitCancelFullScreen ||
    el.mozCancelFullScreen ||
    el.msExitFullscreen
  if (typeof rfs !== 'undefined' && rfs) {
    rfs.call(el)
  }
}
// 错误判断
export const isError = (
  code: any,
  message: any,
  enqueueSnackbar: any,
): boolean => {
  if (+code === -4) {
    return false
  } else if (+code !== 0) {
    // '请求出错'
    enqueueSnackbar(message || transform('error'), {
      variant: 'error',
      autoHideDuration: 2000,
    })
    return false
  }
  return true
}

/**
 * 判断ie11以下
 */
export const isLowIE11 = () => {
  const userAgent = navigator.userAgent
  return userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
}

/**
 * 判断ie
 */
export const isIE = () => {
  const userAgent = navigator.userAgent
  return userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1
}

// 判断谷歌
export const isChrome = () => navigator.userAgent.indexOf('Chrome') > -1

// 判断是否谷歌及某个版本之上
export const checkChromeVersion = (targetVersion = 65) => {
  if (!isChrome()) {
    return false
  }
  const verList = navigator.userAgent.match(/Chrome\/(([0-9]|\.)+)/)
  const ver = verList && verList[1]
  if (ver && +ver.split('.')[0] >= targetVersion) {
    return true
  }
  return false
}

export const composeHocs = (funcs: Array<Many<(...args: any[]) => any>>) => {
  return (Comp: any) =>
    _.flowRight.apply([enhanceLoading, withTracker, withSnackbar, ...funcs])(
      Comp,
    )
}

/** 微信企业浏览器 */
export const isWeiXin = () => navigator.userAgent.indexOf('wxwork') > -1

// 判断是否钉钉环境
export const isDingTalk = navigator.userAgent.indexOf('DingTalk') > -1

/**
 * @description 数字千分位
 * @param {number | string} num
 * @returns {string}
 */
export const formatNum = (num: number | string) => {
  const reg = /\d{1,3}(?=(\d{3})+$)/g
  return `${num}`.replace(reg, '$&,')
}

/**
 * 获取字符串长度，中文2个（包括中文符号和全角字符），英文1个
 * @param {string} str
 *
 */
export const getWordNum = (str: string) => {
  const totalNum = str.length
  // \u4E00-\u9FA5 汉字 \uF900-\uFA2D 中文符号 \uFF00-\uFFEF 全角符号
  const engNum = str.replace(/[\u4E00-\u9FA5\uF900-\uFA2D\uFF00-\uFFEF]/gi, '')
    .length
  return engNum + (totalNum - engNum) * 2
}

/**
 * 按长度截取字符串
 * @param {string} str
 * @param {number} num 字符串最大长度 ，中文2个（包括中文符号和全角字符），英文1个
 */
export const getWordByNum = (str: string, num: number) => {
  let newStr = ''
  let j = 0
  for (let i = 0, len = str.length; i < len; i++) {
    if (/[\u4E00-\u9FA5\uF900-\uFA2D\uFF00-\uFFEF]/gi.test(str[i])) {
      j += 2
    } else {
      j += 1
    }
    if (j > num) {
      break
    } else {
      newStr += str[i]
    }
  }
  return newStr
}
/**
 * 根据秒转化成hh:mm:ss格式
 * @param {number} time
 */
export const timeFormatMMSS = (time: number, maxMinute?: boolean) => {
  const fordateTime = moment.duration(time, 'seconds')
  const hour = fordateTime.hours()
  const min = fordateTime.minutes()
  const second = fordateTime.seconds()
  const pad0 = (num: number) => num.toString().padStart(2, '0')
  if (maxMinute) {
    return `${pad0(hour * 60 + min)} : ${pad0(second)}`
  }
  return `${pad0(hour)} : ${pad0(min)} : ${pad0(second)}`
}
/**
 * 兼容处理requestAnimationFrame
 */
export const initRequestAnimationFrame = () => {
  let lastTime = 0
  const vendors = ['webkit', 'moz']
  vendors.forEach(x => {
    window.requestAnimationFrame = window[`${vendors[x]}RequestAnimationFrame`]
    // Webkit中此取消方法的名字变了
    window.cancelAnimationFrame =
      window[`${vendors[x]}CancelAnimationFrame`] ||
      window[`${vendors[x]}CancelRequestAnimationFrame`]
  })

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = callback => {
      const currTime = new Date().getTime()
      const timeToCall = Math.max(0, 16.7 - (currTime - lastTime))
      const id = window.setTimeout(() => {
        callback(currTime + timeToCall)
      }, timeToCall)
      lastTime = currTime + timeToCall
      return id
    }
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = id => {
      clearTimeout(id)
    }
  }
}

export const StrFromdataFromByte = (strs: string, bytes: number) => {
  let current = ''
  for (const str of strs) {
    if ((current + str).replace(/[^\u0000-\u00ff]/g, 'aa').length > bytes) {
      return `${current}...`
    }
    current += str
  }
  return current
}

export const getUrlParams = (path: string, name: string) => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i')
  const r = path.substr(1).match(reg)
  if (r !== null) {
    return unescape(r[2])
  }
  return null
}

export const getUrlParam = (keyName = '') => {
  const search = location.href.split('?')[1]
  if (search) {
    const tokenStr = search.split('&').find(v => v.includes(keyName))
    return (tokenStr && tokenStr.split('=')[1]) || ''
  }
  return ''
}

export const getHttpsOrigin = () => {
  const origin = window.location.origin
  if (origin.includes('test1') || origin.includes('stg1')) {
    return 'https://test-stg1.zhi-niao.com/znWeb/znPortal'
  } else if (origin.includes('test5') || origin.includes('stg5')) {
    return 'https://test-stg5.zhi-niao.com/znWeb/znPortal'
  } else if (origin.includes('test7')) {
    return 'https://test7.zhi-niao.com/znWeb/znPortal'
  } else if (origin.includes('test9') || origin.includes('stg9')) {
    return 'https://api-stg9.zhi-niao.com/znWeb/znPortal'
  } else if (origin.includes('localhost')) {
    return origin
  }
  return `${origin}/znWeb/znPortal`
}

export const getHttpOrigin = () => {
  const origin = window.location.origin
  if (origin.includes('stg1')) {
    return 'http://test-stg1.zhi-niao.com'
  } else if (origin.includes('stg5')) {
    return 'http://test-stg5.zhi-niao.com'
  } else if (origin.includes('test7')) {
    return 'http://test7.zhi-niao.com'
  } else if (origin.includes('test9')) {
    return 'http://test9.zhi-niao.com'
  }
  return origin
}

// 考试详情页启用摄像头需要使用https, 数据挂在url的data上
export const getDataFromUrl = () => {
  const href = window.location.href
  if (href.indexOf('?') > -1) {
    const data = getQueryParams(href.split('?')[1]).data
    sessionStorage.setItem('dataString', data ? data : '')
    // 如果是考试详情页，为了安全url上的data会被删除，之后读取内容从session中获取
    const dataReg = location.href.match(/([\s\S]+)\?data=[\s\S]+/)
    if (dataReg && dataReg[1]) {
      location.replace(dataReg[1])
    }
    return data ? JSON.parse(b64Decode(data)) : ''
  } else if (sessionStorage.getItem('dataString')) {
    return JSON.parse(b64Decode(sessionStorage.getItem('dataString')))
  }
  return ''
}

export const getOriginFromUrl = () => {
  const data = getDataFromUrl()
  if (data) {
    return data.origin
  }
  return ''
}

export const getUid = () =>
  Math.random()
    .toString(36)
    .slice(2)

/**
 * @description 判断是否为指定IE版本以下
 */
export const IsAvailableIEVersion = (version: number) => {
  // 取得浏览器的userAgent字符串
  const userAgent = navigator.userAgent
  // 判断是否IE浏览器
  const isIE =
    userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
  if (isIE) {
    const reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    const fIEVersion = userAgent.match(reIE)
    return fIEVersion && +fIEVersion[1] < version
  } else {
    return false
  }
}

// 绕过谷歌拦截
export const safeOpen = (url: string) => {
  const a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', 'testNewWindow')
  document.body.appendChild(a)
  a.click()
}

// 获取固定api域名
export const getApiUrl = () => {
  const origin = window.location.origin
  if (origin.includes('stg1') || origin.includes('test1')) {
    return '//api-stg1.zhi-niao.com'
  } else if (origin.includes('stg5') || origin.includes('test5')) {
    return '//api-stg5.zhi-niao.com'
  } else if (origin.includes('test7')) {
    return '//api-stg7.zhi-niao.com'
  } else if (origin.includes('test9')) {
    return '//test9.zhi-niao.com'
  } else if (origin.includes('stg9')) {
    return '//api-stg9.zhi-niao.com'
  } else if (origin.includes('stg11')) {
    return '//hrmsv3-mlearning-dmzstg11.paic.com.cn'
  } else if (origin.includes('localhost')) {
    return '//api-stg1.zhi-niao.com'
  }
  return origin
}


// 获取固定api域名,生产域名有更换（主要用于作业上传接口）
export const getNewApiUrl = () => {
  const url = getApiUrl()
  if (!url) return '//mlearning.pingan.com.cn'
  return url
}

export const getFileFullUrl = (url: any) => {
  if (!url) {
    return ''
  }
  if (url.includes('http')) {
    return url
  }
  return `/learn/app/${url}`
}

const getMonthDays = (date: string) => {
  const curDate = new Date(date)
  const curMonth = curDate.getMonth()
  curDate.setMonth(curMonth + 1)
  curDate.setDate(0)
  return curDate.getDate()
}

// 获取月分对应的日历
export const getMonthDates: any = (date: string) => {
  const values: Moment[] = []
  const month = new Date(date)
  const monthDays = getMonthDays(date)
  const startWeek = month.getDay()
  let days = 35
  if (startWeek + monthDays > days) {
    days = 42
  }
  for (let i = 1; i <= days; i++) {
    if (i <= startWeek) {
      values.push(moment(month).add(-(startWeek - i + 1), 'day'))
    } else {
      values.push(moment(month).add(i - startWeek - 1, 'day'))
    }
  }
  return _.chunk(values, 7)
}

// 获取月的最后一天
export const getMonthLastDate = (d: string) => {
  const date = new Date(d)
  date.setMonth(date.getMonth() + 1)
  const lastDay = date.setDate(0)
  return moment(lastDay).format('YYYY-MM-DD')
}

/**
 * AES解密（CBC模式，需要偏移量）
 * @param data
 * @returns {*}
 */
export const decrypt = (data: any) => {
  // AES 秘钥
  const AesKey = '3c26d0badca24176'
  // AES-128-CBC偏移量
  const CBCIV = '39934fc88c73430e'
  // 加密选项
  const CBCOptions = {
    iv: CryptoJS.enc.Utf8.parse(CBCIV),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }
  const key = CryptoJS.enc.Utf8.parse(AesKey)
  const decrypt = CryptoJS.AES.decrypt(data, key, CBCOptions)
  return JSON.parse(CryptoJS.enc.Utf8.stringify(decrypt))
}

/**
 * @content 对传入的数组，洗牌乱序算法
 * @param arr 数组
 */
export const shuffle = (arr: any) => {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    if (j === i) {
      continue
    }
    [arr[i], arr[j]] = [arr[j], arr[i]]
  }
  return arr
}

/**
 * @content 数组按固定长度分割
 * @param arr 数组
 * @param sliceNum 多少长度分割
 *
 * @example
 *  const arr =[1,2,3,4,5]
 *  sliceLength(arr, 2) => [[1,2], [3,4], [5]]
 */
export const sliceLength = (arr: any, sliceNum: number) => {
  const newArr: any = []
  if (arr && arr.length > sliceNum) {
    for (let i = 0; i < arr.length; i += sliceNum) {
      newArr.push(arr.slice(i, i + sliceNum))
    }
  }
  return newArr
}

/**
 * @description 返回日期格式如：2019.02.02. 02:02
 * @param d
 */
export const formateTime = (d: string) => {
  return moment(d).format('YYYY.MM.DD HH:mm')
}

/**
 * @description 知圈收藏点赞评论数
 * @param d
 */
export const transformNum = (num: number) => {
  if (num < 10000) {
    return num
  } else {
    // `${Number(Math.floor(num / 1000) / 10).toFixed(1)}万`
    return transform('knowledgeLib_ten_thousand', {
      n: Number(Math.floor(num / 1000) / 10).toFixed(1),
    })
  }
}

// 寿险
export const isPingAnSx = (): boolean => {
  const { allFullPath = '' } = Store.get('oldAppUserInfo') || {}
  const sxId = [
    '0DE29484A7187032E054A0369F1934EC',
    '0DE29484A71C7032E054A0369F1934EC',
  ]
  return allFullPath.includes(sxId[0]) || allFullPath.includes(sxId[1])
}

/**
 * 数组元素交换位置
 * @param {array} arr 数组
 * @param {number} index1 添加项目的位置
 * @param {number} index2 删除项目的位置
 * index1和index2分别是两个数组的索引值，即是两个要交换元素位置的索引值，如1，5就是数组中下标为1和5的两个元素交换位置
 */
export const swapArray = (arr: any[], index1: number, index2: number) => {
  arr[index1] = arr.splice(index2, 1, arr[index1])[0]
  return arr
}

// 下载图片
export const downloadFile = (url: string, name: string, prefixFlag?: boolean) => {
  const hasHttp = url.substr(0, 4).toLowerCase() === 'http'
  const goToUrl = hasHttp ? url : `${prefixFlag ? getPrefixApp().ADMIN : ''}/learn/${url}`
  if (isIE()) {
    const ieA = document.createElement('a')
    ieA.setAttribute('href', goToUrl)
    ieA.setAttribute('download', name)
    ieA.text = ''
    document.body.appendChild(ieA)
    ieA.click()
  } else {
    const x = new XMLHttpRequest()
    x.open('GET', goToUrl, true)
    x.responseType = 'blob'
    x.onload = e => {
      const downloadUrl = window.URL.createObjectURL(x.response)
      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = name
      a.click()
    }
    x.send()
  }
}

// 是否邮箱格式
export const validateEmail = (email: string) => {
  const emailReg = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/
  if (emailReg.test((email) && (email).toLowerCase())) {
    return true
  }
  return false
}

// 复制
export const copyLink = (text: any) => {
  const textarea = document.createElement('textarea') // 创建input对象
  const toolBoxwrap = document.getElementsByTagName('body')[0] // 将文本框插入到NewsToolBox这个之后
  toolBoxwrap.appendChild(textarea) // 添加元素
  textarea.value = text
  textarea.focus()
  if (textarea.setSelectionRange) {
    textarea.setSelectionRange(0, textarea.value.length) // 获取光标起始位置到结束位置
  } else {
    textarea.select()
  }
  let flag = false
  try {
    flag = document.execCommand('copy') // 执行复制
  } catch (eo) {
    flag = false
  }
  toolBoxwrap.removeChild(textarea) // 删除元素

  if (flag) {
    global.$message('复制成功', {
      variant: 'success',
      autoHideDuration: 1500,
    })
  } else {
    global.$message('复制失败')
  }

  return flag
}

export const addWaterMarker = (str: string, boxObj: any, needDeleteDom?: string): void => {
  const can = document.createElement('canvas')
  const div = document.createElement('div')
  const span = document.createElement('span')
  span.innerHTML = str
  span.style.display = 'none'
  const body = boxObj
  body.appendChild(div)
  body.appendChild(span)
  can.width = span.clientWidth * 2 > 200 ? span.clientWidth * 2 : 200 // 画布的宽 最小200
  can.height = can.width // 画布的高度
  can.style.display = 'block'
  const cans: any = can.getContext('2d')
  cans.font = '14px' // 画布里面文字的字体
  cans.fillStyle = 'rgba(153, 153, 153, 0.2)' // 画布里面文字的颜色
  cans.textAlign = 'left' // 画布里面文字的水平位置
  cans.textBaseline = 'Middle' // 画布里面文字的垂直位置
  cans.rotate( - Math.PI / 7) // 画布里面文字的间距比例
  cans.fillText(str, 0, can.height / 2)
  div.id = needDeleteDom || ''
  div.style.position = 'absolute'
  div.style.left = '0'
  div.style.bottom = '0'
  div.style.width = '100%' // 画布的宽
  div.style.height = '100%' // 画布的高度
  div.style.pointerEvents = 'none' // 点击穿透
  div.style.backgroundImage = `url(${can.toDataURL('image/png')})` // 把画布插入到body中
}

// 用**替换敏感词
export const shieldSensitive = (str: string, type: string) => {
  if (!str) return str
  let sensitive = localStorage.getItem('sensitiveList')
  let topic = localStorage.getItem('topic')
  let task = localStorage.getItem('task')
  let viewStr = str
  if (type === 'topic' && !Number(topic)) return viewStr
  if (type === 'task' && !Number(task)) return viewStr
  let re = new RegExp(`${sensitive}`, 'g')
  return viewStr.replace(re, '**')
}

export const getSensitiveList = async () => {
  let pageSize = 10000
  let pageNo = 1
  let sensitiveList = []
  let data = {
    pageSize,
    pageNo,
    sensitiveName: ''
  }
  const res = await Login.getSensitiveList(data)
  if (res.code === 0) {
    const body = res.body
    sensitiveList = sensitiveList.concat(body.data.sensitiveNameList)
    if (body.total > pageSize * pageNo) {
      const maxPageNo = Math.ceil(body.total / pageSize)
      const getPromises = []
      while (maxPageNo >= pageNo) {
        pageNo++
        data.pageNo = pageNo
        getPromises.push(Login.getSensitiveList(data) as never)
      }
      const res2 = await Promise.all(getPromises)
      res2.forEach((item: any) => {
        if (item.code === '0') {
          sensitiveList = sensitiveList.concat(item.body.data.sensitiveNameList)
        }
      })
    }
    let str = sensitiveList.join('|')
    localStorage.setItem('sensitiveList', str)
    localStorage.setItem('topic', body.data.knowFlag)
    localStorage.setItem('task', body.data.workFlag)
  }
}
